import { Component, inject } from "@angular/core";
import { StrategyEx } from "@front/m19-models";
import { StrategyActivityComponent } from "@m19-board/strategies/strategies/strategy-activities/strategy-activities.component";
import { MODAL_DATA, ModalRef } from "@front/m19-ui";

@Component({
  template: ` <div class="min-w-[70vw] p-3">
    <app-strategy-activity-component [strategy]="data.strategy"></app-strategy-activity-component>
  </div>`,
  styles: [".activity-section {height: 30rem;}"],
  standalone: true,
  imports: [StrategyActivityComponent],
})
export class StrategyActivityModalComponent {
  private readonly modalRef = inject(ModalRef);
  readonly data = inject<StrategyActivityModalData>(MODAL_DATA);

  close() {
    this.modalRef.close();
  }
}

export interface StrategyActivityModalData {
  strategy: StrategyEx;
}
